import { jsxs as i, jsx as r } from "react/jsx-runtime";
function t(l) {
  return /* @__PURE__ */ i(
    "svg",
    {
      width: "42",
      height: "42",
      viewBox: "0 0 40 41",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...l,
      children: [
        /* @__PURE__ */ r("g", { clipPath: "url(#clip0_204047_1251)", children: /* @__PURE__ */ i("g", { clipPath: "url(#clip1_204047_1251)", children: [
          /* @__PURE__ */ r(
            "path",
            {
              d: "M34 0.716309H6C2.68629 0.716309 0 3.4026 0 6.71631V34.7163C0 38.03 2.68629 40.7163 6 40.7163H34C37.3137 40.7163 40 38.03 40 34.7163V6.71631C40 3.4026 37.3137 0.716309 34 0.716309Z",
              fill: "#2D8CFF"
            }
          ),
          /* @__PURE__ */ r(
            "path",
            {
              d: "M33.4375 28.6069C34.0625 28.7632 34.6094 28.4507 34.9219 27.9819C35.0781 27.7476 35.0781 27.3569 35.0781 26.4976V14.7007C35.0781 13.8413 35.0781 13.5288 34.9219 13.2163C34.6875 12.5913 34.0625 12.3569 33.4375 12.5913C31.7969 13.6851 28.2031 16.8882 28.125 18.2163C28.0625 18.4507 28.0625 18.8413 28.0625 19.3882V22.3569C28.0625 22.9819 28.0625 23.2163 28.125 23.5288C28.2031 24.1538 28.4375 24.7007 28.75 25.0132C29.6875 25.7163 32.8125 28.5288 33.5156 28.5288L33.4375 28.6069ZM5 15.3257C5 14.1538 5 13.5288 5.23438 13.2163C5.39062 12.9038 5.85938 12.5913 6.09375 12.3569C6.40625 12.1226 6.95312 12.1226 8.20312 12.1226H18.2812C21.25 12.1226 22.7344 12.1226 23.9062 12.7476C24.7656 13.3726 25.7031 13.9194 26.25 15.0913C26.875 16.2632 26.875 17.7476 26.875 20.7163V26.0288C26.875 27.2007 26.875 27.8257 26.6406 28.1382C26.4844 28.4507 26.0156 28.7632 25.7812 28.9976C25.4688 29.2319 24.9219 29.2319 23.6719 29.2319H13.5938C10.625 29.2319 9.14062 29.2319 7.96875 28.6069C7.10938 27.9819 6.17188 27.4351 5.625 26.2632C5 25.0913 5 23.6069 5 20.6382V15.3257Z",
              fill: "rgb(var(--background-secondary))"
            }
          )
        ] }) }),
        /* @__PURE__ */ i("defs", { children: [
          /* @__PURE__ */ r("clipPath", { id: "clip0_204047_1251", children: /* @__PURE__ */ r(
            "rect",
            {
              y: "0.716309",
              width: "40",
              height: "40",
              rx: "6",
              fill: "rgb(var(--background-secondary))"
            }
          ) }),
          /* @__PURE__ */ r("clipPath", { id: "clip1_204047_1251", children: /* @__PURE__ */ r(
            "rect",
            {
              width: "40",
              height: "40",
              fill: "rgb(var(--background-secondary))",
              transform: "translate(0 0.716309)"
            }
          ) })
        ] })
      ]
    }
  );
}
export {
  t as ZoomIntegrationIcon
};
